import styled from 'styled-components'

export const TableDiv = styled.div`
display: flex;
width: 100%;
font-size: .875rem;
table, th, td {
  border: 2px solid var(--c4);
  border-collapse: collapse;
  font-family: 'Roboto','sans-serif';
}

table{
    width: 100%;
}

th,td{
    max-width: 12rem;
    padding: .325rem .75rem .325rem .75rem;
}

td{
    transition: 2s;
    text-align: center;
}

th{
    background: var(--Azul);
    color: var(--c1);
    font-weight: 500;
}
.dropDownTr{
    background: #3984C415 !important;
    color: var(--Preto);
    font-weight: bold;
}

tr:not(:first-child){
color: var(--Preto);
}
`

export const StyledTd = styled.td`
    color: ${props => props.theme};
    font-weight: bold;
`
